import { render, staticRenderFns } from "./SkeletonPhoneComponentGlobal.vue?vue&type=template&id=22a24ece&scoped=true&"
import script from "./SkeletonPhoneComponentGlobal.vue?vue&type=script&lang=js&"
export * from "./SkeletonPhoneComponentGlobal.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonPhoneComponentGlobal.vue?vue&type=style&index=0&id=22a24ece&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a24ece",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VRow,VSkeletonLoader})
